import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c7b0d85"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-base-info" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "img-box" }
const _hoisted_5 = ["src"]

import { ref, watch } from 'vue'
import Text from '@/components/text'
import { get, isEmpty } from 'lodash'
import moment from 'moment'
import { formatLat, formatLng } from '@/utils/map.utils'
import defaultImg from '@/assets/img/site/site-default.png'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'site-info',
  props: ['data'],
  setup(__props) {

const props = __props;

const t = i18n.global.t



watch(
  () => props.data,
  () => {
    if (!isEmpty(props.data)) {
      dealwidthData(props.data)
    }
  },
  {
    deep: true,
    immediate: true,
  }
)

const productImg = ref(defaultImg)
const deviceInfo: any = ref({})
const dealwidthData = (resData?: any) => {
  const data = resData || {}
  deviceInfo.value = data
  baseInfo.value = baseInfo.value.map((item: any) => {
    if (item.formatter) {
      return {
        ...item,
        value: item.formatter(data),
      }
    } else {
      return {
        ...item,
        value: data[item.key],
      }
    }
  })
  const { picUrl, picBaseUrl } = data
  if (picUrl) {
    productImg.value = picBaseUrl + picUrl
  }
}

const baseInfo = ref([
  {
    title: '',
    value: '',
    key: 'name',
    class: 'device-name ws_mb20',
    span: 24,
  },

  {
    title: t('SITE.col2') + ' : ',
    value: '',
    key: 'orgName',
  },
  {
    title: t('SITE.address') + ' : ',
    value: '',
    key: 'locationAddress',
  },
  {
    title: t('SITE.desc') + ' : ',
    value: '',
    key: 'describe',
    span: 24,
  },
])

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('SITE.siteInfomation')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!_unref(isEmpty)(deviceInfo.value))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: productImg.value,
              alt: ""
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_row, {
        gutter: 20,
        class: "base-info"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseInfo.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_col, {
              span: item.span || 12,
              key: index,
              class: _normalizeClass(["ws_mb36", item.class])
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Text), {
                  content: item.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title) + _toDisplayString(item.value || '-'), 1)
                  ]),
                  _: 2
                }, 1032, ["content"])
              ]),
              _: 2
            }, 1032, ["span", "class"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})